import logo_icon from "./../assets/logo_icon.png";
import dashboard_icon from "./../assets/dashboard_icon.png";
import notification_bell from "./../assets/notification_bell.svg";
import dashboard_logo from "./../assets/dashboard_logo.svg";
import counter from "./../assets/counter.png";
import RBAC_icon from "./../assets/RBAC_icon.png";
import staff_icon from "./../assets/staff_icon.png";
import bell from "./../assets/bell.png";
import cross from "./../assets/cross.png";
import Status_icon from "./../assets/Status_icon.png";
import delete_warning from "./../assets/delete_warning.png";
import kiosk_logo from "./../assets/kiosk_logo.png";
import close from "./../assets/close.png";
import services from "./../assets/services.png";
import dpt_icon from "./../assets/dpt_icon.png";
import dental from "./../assets/kiosk-assets/dental.png";
import cardImg from "./../assets/kiosk-assets/cardImg.png";
import attest_doc from "./../assets/kiosk-assets/attest_doc.png";
import verify_doc from "./../assets/kiosk-assets/verify_doc.png";
import inquiry from "./../assets/kiosk-assets/inquiry.png";
import course from "./../assets/kiosk-assets/course.png";
import scholarship from "./../assets/kiosk-assets/scholarship.png";
import exam from "./../assets/kiosk-assets/exam.png";

const IMAGES = {
  logo_icon,
  notification_bell,
  dashboard_logo,
  dashboard_icon,
  counter,
  RBAC_icon,
  staff_icon,
  bell,
  cross,
  Status_icon,
  delete_warning,
  kiosk_logo,
  close,
  services,
  dpt_icon,
};

const kiosk_IMAGES = {
  dental,
  cardImg,
  attest_doc,
  verify_doc,
  inquiry,
  course,
  scholarship,
  exam,
};

export { IMAGES, kiosk_IMAGES };
